import { render } from "./QuestionSet.vue?vue&type=template&id=a0677a88"
import script from "./QuestionSet.vue?vue&type=script&lang=js"
export * from "./QuestionSet.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__